import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { API } from "@/App";
import AxiosDB from "@/Config/AxiosDB";

/**
 * Autologin vía token.
 * Uso: /autologin?token=JWT[&redirect=/ruta]
 * Guarda el token, valida con /api/auth/me y entra a la app.
 */
export default function Autologin({ onLogin }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const token = searchParams.get("token");
    const redirect = searchParams.get("redirect") || "/";

    if (!token) {
      setError("No se proporcionó un token en la URL.");
      const t = setTimeout(() => navigate("/login", { replace: true }), 1500);
      return () => clearTimeout(t);
    }

    const doLogin = async () => {
      try {
        localStorage.setItem("token", token);
        localStorage.removeItem("impersonating");
        const res = await axios.get(`${AxiosDB.defaults.baseURL}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        onLogin(token, res.data);
        navigate(redirect, { replace: true });
      } catch (e) {
        localStorage.removeItem("token");
        setError("Token inválido o expirado. Redirigiendo al inicio de sesión...");
        setTimeout(() => navigate("/login", { replace: true }), 1800);
      }
    };
    doLogin();
  }, [searchParams, navigate, onLogin]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-slate-50 to-blue-50" data-testid="autologin-page">
      <div className="text-center">
        {error ? (
          <p className="text-red-600" data-testid="autologin-error">{error}</p>
        ) : (
          <>
            <div className="w-10 h-10 mx-auto mb-4 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin" />
            <p className="text-lg text-slate-600">Iniciando sesión...</p>
          </>
        )}
      </div>
    </div>
  );
}
